module.exports = __webpack_public_path__ + "static/media/circle_1.89944b3f.svg";